import React from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

const CTAContain = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 1rem;
`;

const FormContain = styled.div`
  background: #fff;
  display: inline-block;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.1);
  position: relative;
  width: 100%;
  margin: 0 auto;
`;

const Heading = styled.h3`
  text-transform: uppercase;
  font-size: 1.2rem;
  color: #4a5568;
  font-weight: 600;
  margin: 0 0 1rem;
  letterspacing: 0.01rem;
`;

const Elements = styled.form`
  margin: 0 0 1rem;

  label {
    display: block;
    width: 100%;
  }

  label > input {
    font-size: 1rem;
    background: #edf2f7;
    font-weight: 500;
    border: 1px solid #cbd5e0;
    padding: 0.8rem;
    border-radius: 4px;
    width: 100%;
  }
`;

const Notice = styled.div`
  margin: 0 0 1rem;
  display: flex;
  align-items: center;
  color: #38a169;
  font-weight: 500;
  line-height: 1.3;

  svg {
    width: 32px;
  }

  span {
    display: inline-block;
    padding-left: 0.2rem;
  }
`;

const Inputs = styled.div`
  display: flex;
  margin: 0 -0.5rem;

  > label {
    padding: 0 0.5rem;
  }
`;

const Legal = styled.div`
  max-width: 20rem;
  font-size: 0.8rem;
  text-align: center;
  margin: 0 auto;
  color: #a0aec0;

  > a {
    color: #a0aec0;
    text-decoration: underline;
  }
`;

const Button = styled.button`
  margin-top: 1rem;
  color: #fff;
  background: #46a85c;
  border: 1px solid #38a169;
  border-radius: 4px;
  font-size: 1rem;
  padding: 0.8rem;
  cursor: pointer;
  width: 100%;
  font-weight: 600;

  &:hover {
    background: #38a169;
  }
`;

export default class Form extends React.Component {
  state = {
    Name: "",
    Email: "",
    Phone: "",
    step: 1,
    notice: "",
    title: "Get a Quickpage example sent to you now.",
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  submitHandler = (e) => {
    e.preventDefault();
    const form = e.target;
    const { Name, Email, Phone, step } = this.state;

    if (step === 1 && !Email) {
      return toast.error("Please add your email address.");
    }

    if (step === 2 && (!Name || !Phone)) {
      return toast.error("Please fill all the fields.");
    }

    const body = { Name, Email, Phone, Industry: "real-estate" };
    let notice = "Quickpage Delivered. Check your inbox.";
    let title = "Would you like to receive it by text too?";

    if (step === 2) {
      notice = "Quickpage Delivered. Check your phone.";
      title = "Thank you!";
    }

    fetch("https://beta.quickpageapp.com/forms/netlify/kwrur", {
      method: "POST",
      mode: "no-cors",
      headers: {
        Accept: "application/x-www-form-urlencoded;charset=UTF-8",
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      body: encode({ "form-name": form.getAttribute("name"), ...body }),
    })
      .then(() => {
        this.setState({
          step: step + 1,
          notice,
          title,
        });
      })
      .catch((error) => {
        console.log(error);
        toast.error("Something went wrong. Please try again.");
      });
  };

  render() {
    const { step, Name, Phone, Email, notice, title } = this.state;

    return (
      <CTAContain>
        <FormContain>
          {notice && (
            <Notice>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
              >
                <circle cx="12" cy="12" r="12" fill="#38A169"></circle>
                <path
                  fill="#fff"
                  d="M10.329 18.859c-.427 0-.83-.2-1.09-.542l-3.502-4.623A1.365 1.365 0 016 11.78a1.365 1.365 0 011.914.265l2.304 3.042 5.795-9.303a1.368 1.368 0 012.32 1.445l-6.845 10.987a1.362 1.362 0 01-1.16.643z"
                ></path>
              </svg>
              <span>{notice}</span>
            </Notice>
          )}

          <Heading>{title}</Heading>

          <Elements
            name="page-request-kwrur"
            method="post"
            action="https://beta.quickpageapp.com/forms/netlify/kwrur"
            data-netlify="true"
            onSubmit={this.submitHandler}
          >
            <input type="hidden" name="form-name" value="page-request-kwrur" />
            <input type="hidden" name="Industry" value="real-estate" />
            {step === 1 ? (
              <>
                <input type="hidden" name="Name" value={Name} />
                <input type="hidden" name="Phone" value={Phone} />
                <label>
                  <input
                    type="email"
                    value={Email}
                    name="Email"
                    placeholder="Email Address"
                    onChange={this.handleChange}
                    required
                  />
                </label>

                <Button type="submit">SEND ME A QUICKPAGE</Button>
              </>
            ) : step !== 3 ? (
              <>
                <Inputs>
                  <input type="hidden" name="Email" value={Email} />
                  <label>
                    <input
                      type="text"
                      value={Name}
                      name="Name"
                      placeholder="Name"
                      onChange={this.handleChange}
                      required
                    />
                  </label>

                  <label>
                    <input
                      type="text"
                      value={Phone}
                      name="Phone"
                      placeholder="Phone"
                      onChange={this.handleChange}
                      required
                    />
                  </label>
                </Inputs>

                <Button type="submit">SEND ME A QUICKPAGE BY TEXT</Button>
              </>
            ) : (
              ""
            )}
          </Elements>

          <Legal>
            By clicking{" "}
            <strong>
              {step === 1
                ? "“SEND ME A QUICKPAGE”"
                : "“SEND ME A QUICKPAGE BY TEXT”"}
            </strong>{" "}
            I agree to Quickpage{" "}
            <a
              href="https://quickpage.io/terms"
              rel="noopener noreferrer"
              target="_blank"
            >
              Terms of Service
            </a>{" "}
            and{" "}
            <a
              href="https://quickpage.io/privacy"
              rel="noopener noreferrer"
              target="_blank"
            >
              Privacy Policy
            </a>
          </Legal>
        </FormContain>
      </CTAContain>
    );
  }
}
